import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import userStorage from '@/shared/services/userStorage';
const storageKey = 'sidebarCollapsed';
const CollapsableSidebar = ({ children }) => {
    const [isCollapsed, setCollapsed] = useState(userStorage.getItem(storageKey) || false);
    const [isLoading, setIsLoading] = useState(true);
    const [sidebar, mainView] = children;
    useEffect(() => {
        setIsLoading(false);
    }, []);
    useEffect(() => {
        userStorage.setItem(storageKey, isCollapsed);
    }, [isCollapsed]);
    return (_jsxs("div", Object.assign({ className: classnames('sidebar-wrapper', {
            'sidebar-collapsed': isCollapsed,
            'sidebar-loading': isLoading,
        }) }, { children: [_jsx("div", Object.assign({ className: "sidebar" }, { children: sidebar })), _jsx("div", Object.assign({ className: "gap" }, { children: _jsx("a", Object.assign({ onClick: () => setCollapsed(x => !x), className: "sidebar-toggle" }, { children: _jsx("i", { className: classnames('fa ', isCollapsed ? 'fa-chevron-circle-right' : 'fa-chevron-circle-left') }) })) })), _jsx("div", Object.assign({ className: "mainview" }, { children: mainView }))] })));
};
export default CollapsableSidebar;
